import { createI18n } from 'vue-i18n';
import ru from './locales/ru.json';
import en from './locales/en.json';

/**
 * Список поддерживаемых языков. Когда добавляешь новый — добавь сюда +
 * импорт locales/<lang>.json + кейс в `useLocaleStore.detect()`.
 */
export const SupportedLocales = ['ru', 'en'] as const;
export type Locale = (typeof SupportedLocales)[number];

export const LocaleLabels: Record<Locale, string> = {
    ru: 'Русский',
    en: 'English'
};

export const i18n = createI18n({
    legacy: false, // Composition API (`useI18n()`)
    locale: 'ru',
    fallbackLocale: 'en',
    messages: { ru, en },
    // missingWarn выключаем чтобы консоль не засирать пока часть views
    // ещё не локализована (используют hardcoded русские строки).
    missingWarn: false,
    fallbackWarn: false
});

/** Переводит i18n key, не показывая пользователю техническую строку с точками. */
export function translateLabel(value: string, fallback?: string): string {
    if (!value) return '';
    void i18n.global.locale.value;
    if (i18n.global.te(value)) return i18n.global.t(value);
    if (fallback) return fallback;
    if (!value.includes('.')) return value;

    const tail = value.split('.').pop() ?? value;
    return tail
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[-_]+/g, ' ')
        .replace(/^./, (letter) => letter.toUpperCase());
}
